import { isValid, parse, parseISO } from 'date-fns';

export const isValidDate = (dateString: string, format = 'MM/dd/yyyy'): boolean => {
  const parseDate = parse(dateString, format, new Date());
  return isValid(parseDate);
};

export const isValidIsoDate = (date: string): boolean => {
  const parsedDate = parseISO(date);
  return isValid(parsedDate);
};

export const isIsoDateStringOnOrAfterCompareDate = ({
  date,
  compareDate,
}: {
  date: string;
  compareDate: string;
}): boolean => {
  if (date === '' || compareDate === '') return false;

  const dateParsed = new Date(date);
  const compareDateParsed = new Date(compareDate);
  return dateParsed >= compareDateParsed;
};
